import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { ReactiveFormsModule } from '@angular/forms';
import { ComponentsModule } from 'src/app/components/components.module';
import { EnrollBoydRewardsComponent } from './enroll-boyd-rewards.component';



@NgModule({
  declarations: [
    EnrollBoydRewardsComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    ComponentsModule
  ],
  exports:[
    EnrollBoydRewardsComponent
  ]
})
export class EnrollBoydRewardsModule { }
